_ = require('lodash')

ContactService = ($http) ->
  send: (data) ->
    params = _.merge {}, data,
      localtime: (new Date()).toString()
    $http.post("/api/inquiry/send.json", params)

ContactService.$inject = [
  '$http'
]

module.exports = ContactService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/contact/contact-service.coffee